import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { getSpacing } from '../../const/spacing';
import { Icon } from '../Icon/Icon';
import { IconPlaceholder } from '../Icon/IconPlaceholder';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
const BORDER_RADIUS = sizes.dynamicTable.headerBorderRadius;
const StyledDynamicTableHeaderCellContentWrapper = styled('div', ({ $totalColumns, $columnIndex }) => {
    const isFirstColumn = $columnIndex === 0;
    const isLastColumn = $columnIndex >= $totalColumns - 1;
    return {
        backgroundColor: staticColors.dynamicTableHeaderBackground,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        borderTopLeftRadius: isFirstColumn ? BORDER_RADIUS : undefined,
        borderBottomLeftRadius: isFirstColumn ? BORDER_RADIUS : undefined,
        borderTopRightRadius: isLastColumn ? BORDER_RADIUS : undefined,
        borderBottomRightRadius: isLastColumn ? BORDER_RADIUS : undefined,
    };
});
const StyledDynamicTableHeaderCell = styled('th', {
    padding: `0 0 ${getSpacing('3/2')} 0`,
});
const sortIconMap = {
    asc: 'ArrowDropUp',
    desc: 'ArrowDropDown',
};
export const DynamicTableHeaderCell = ({ totalColumns, columnIndex, isSortable, sortDirection, onClick, children, }) => {
    const sortIcon = isSortable && sortDirection ? (_jsx(Icon, { name: sortIconMap[sortDirection] })) : (_jsx(IconPlaceholder, {}));
    const cellContent = (_jsxs(FlexContainer, { direction: 'row', verticalAlign: 'center', spacingHorizontal: true, spacingVertical: true, children: [_jsx(Text, { variant: 'b2', color: 'dark', underline: isSortable, as: 'div', children: children }), sortIcon] }));
    const content = isSortable ? (_jsx(PlainButton, { onClick: onClick, children: cellContent })) : (cellContent);
    return (_jsx(StyledDynamicTableHeaderCell, { children: _jsx(StyledDynamicTableHeaderCellContentWrapper, { $totalColumns: totalColumns, $columnIndex: columnIndex, children: content }) }));
};
